import { API, post } from 'utils/api';

import type { ApiUploadEvent } from 'types';

export type CollabaryVideoUploadResponse = {
  data: {
    key: string,
    url: string,
    name: null,
    size: number,
    mimeType: string
  },
  signature: string
};

export async function uploadCollabaryVideo(
  file: File,
  onUploadProgress?: (progressEvent: ApiUploadEvent) => void
): Promise<CollabaryVideoUploadResponse> {
  const url = API.END_POINTS.API.UPLOAD;
  const sizeTotal = file.size;

  const { data } = (await post(url, {
    data: file,
    headers: {
      'Content-Type': file.type
    },
    onUploadProgress: (event) => {
      onUploadProgress?.({
        total: sizeTotal,
        loaded: event.loaded
      });
    }
  })) as { data: CollabaryVideoUploadResponse };

  return data;
}
